import { render, staticRenderFns } from "./goDialog.vue?vue&type=template&id=590eb6e5"
import script from "./goDialog.vue?vue&type=script&lang=js"
export * from "./goDialog.vue?vue&type=script&lang=js"
import style0 from "./goDialog.vue?vue&type=style&index=0&id=590eb6e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports